import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

interface InputResume {
  pasien_rm: number;
  dpjp_id: number;
  discharge_id: number;
  rujukan_ke: string;
  catatan: string;
  // diagnosis: [];
  // prosedur: [];
}

async function create(register_id: number, data: InputResume) {
  const response = await http
    .postData(`/register/${register_id}/resume-ralan-paket`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function update(register_id: number, data: InputResume) {
  const response = await http
    .putData(`/register/${register_id}/resume-ralan-paket`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {}

async function find(id: number) {}

async function quickSign(regNo) {
  const resp = await http
    .postData(`/register/${regNo}/resume-ralan-paket/quick-signature`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return resp;
}

async function remove(id: number) {
  const response = await http.deleteData(`/resume-ralan/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

export default {
  create,
  update,
  getByRegister,
  find,
  quickSign,
  remove
};
